/**
 * RESPONSIBILITY: the Children's page closing invitation.
 */
import type { ChildrenCtaSection } from '@app/sections';
import { Page, hrefFor } from '../commons/pages';

export function ChildrenCta({ c }: { c: ChildrenCtaSection }) {
  return (
    <section className="band band-sand band-centre">
      <div className="wrap">
        <h2>{c.ctaHeading}</h2>
        {c.ctaBody && <p className="lede">{c.ctaBody}</p>}
        <div className="btns btns-centre">
          {c.ctaLabel && (
            <a className="btn" href={c.ctaHref || hrefFor(Page.Contact)}>{c.ctaLabel}</a>
          )}
        </div>
      </div>
    </section>
  );
}
